import { MouseEvent, cloneElement, ComponentProps } from 'react';

import { Button } from '@hh.ru/magritte-ui-button';
import { ButtonElement } from '@hh.ru/magritte-ui-button-stack';

interface DropButtons {
    selectFileButton?: ButtonElement;
    deleteFileButton?: ButtonElement;
    replaceImageButton?: ButtonElement;
}

interface UseDropButtonsProps extends DropButtons {
    onFileDelete?: (event: MouseEvent) => void;
}

const useDropButtons = ({
    selectFileButton: _selectFileButton,
    deleteFileButton: _deleteFileButton,
    replaceImageButton: _replaceImageButton,
    onFileDelete,
}: UseDropButtonsProps): DropButtons => {
    const selectFileButton =
        _selectFileButton &&
        cloneElement(_selectFileButton, {
            key: 'selectFileButton',
            'data-qa': 'magritte-select-file-button',
        } as Partial<ComponentProps<typeof Button>>);

    const deleteFileButton =
        _deleteFileButton &&
        cloneElement(_deleteFileButton, {
            key: 'deleteFileButton',
            'data-qa': 'magritte-delete-file-button',
            onClick: onFileDelete,
        } as Partial<ComponentProps<typeof Button>>);

    const replaceImageButton =
        _replaceImageButton &&
        cloneElement(_replaceImageButton, {
            key: 'replaceImageButton',
            'data-qa': 'magritte-select-replace-image-button',
        } as Partial<ComponentProps<typeof Button>>);

    return { selectFileButton, deleteFileButton, replaceImageButton };
};

export { useDropButtons };
